<template>
    <section class="my-4 mx-4">
        <h3 class="p-4 text-lg font-bold">Plan</h3>
        <div class="bg-gray-light py-4 px-8 rounded md:flex md:items-center">
            <div class="py-2 px-4 rounded-md bg-white">
                <strong>{{ current.plan_price }}</strong>
                <span class="text-sm" v-if="isStatus('recurring')">Next, you'll be charged <strong>{{ current.next_price }}</strong> on <strong>{{ current.next_on }}</strong></span>
                <span class="text-sm" v-if="isStatus('canceled')">Membership will end on <strong>{{ current.ends_on }}</strong></span>
            </div>
            <div class="mt-2 md:ml-2 md:mt-0 flex">
                <button
                    class="py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold"
                    :loading="false"
                    :state="'...'"
                    @click="toggleChanging"
                    v-if="isStatus('recurring')"
                >
                    <strong>{{ changing ? 'Cancel changing' : 'Change plan'}}</strong>
                </button>
                <button
                    class="py-2 px-4 rounded-md bg-transparent text-destructive font-bold ml-2"
                    :loading="false"
                    :state="'...'"
                    @click="unsubscribe"
                    v-if="isStatus('recurring')"
                >
                    Cancel membership
                </button>
                <button
                    class="py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold"
                    :loading="false"
                    :state="'...'"
                    @click="resume"
                    v-if="isStatus('canceled')"
                >
                    <strong>Resume membership</strong>
                </button>
            </div>
        </div>
        <div v-if="changing">
            <div :is="this.picker" :plan="current.id" :endpoint="endpoint"></div>
        </div>
    </section>
</template>

<script>
import UnsubscribeModal from './UnsubscribeModal';
import ResumeSubscriptionModal from './ResumeSubscriptionModal';

export default {
    props: {
        status: {
            type: String,
            required: true,
        },
        plan: {
            type: Object,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
        picker: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            current: this.plan,
            changing: false,
        }
    },
    methods: {
        isStatus(status) {
            return status === this.status;
        },
        toggleChanging() {
            this.changing = !this.changing;
        },
        unsubscribe() {
            Modal.show(UnsubscribeModal, {propsData: {
                endpoint: this.endpoint,
            }}).then(response => {
                window.location.reload();
            }).catch(console.error);
        },
        resume() {
            Modal.show(ResumeSubscriptionModal, {propsData: {
                endpoint: this.endpoint,
            }}).then(response => {
                window.location.reload();
            }).catch(console.error);
        }
    }
}
</script>